export default "__VITE_ASSET__CmuLHCQz__"